import type { Lang } from './i18n';

export const ROUTES = ['home', 'waste', 'vision', 'demo', 'privacy', 'terms'] as const;
export type Route = (typeof ROUTES)[number];

export const PATHS: Record<Route, string> = {
  home: '/',
  waste: '/waste',
  vision: '/vision',
  demo: '/demo',
  privacy: '/privacy',
  terms: '/terms',
};

export const AR_PREFIX = '/ar';

export type Line = 'waste' | 'vision' | 'both';

export function stripLangPrefix(pathname: string): { lang: Lang; path: string } {
  const clean = pathname.replace(/\/index\.html$/, '').replace(/\/+$/, '') || '/';
  if (clean === AR_PREFIX) return { lang: 'ar', path: '/' };
  if (clean.startsWith(`${AR_PREFIX}/`)) return { lang: 'ar', path: clean.slice(AR_PREFIX.length) || '/' };
  return { lang: 'en', path: clean };
}

export function routeFromPath(pathname: string): Route {
  const { path } = stripLangPrefix(pathname);
  return ROUTES.find((r) => PATHS[r] === path) ?? 'home';
}

export function parseLocation(pathname: string): { lang: Lang; route: Route } {
  const { lang, path } = stripLangPrefix(pathname);
  return { lang, route: ROUTES.find((r) => PATHS[r] === path) ?? 'home' };
}

export function pathFor(route: Route, lang: Lang): string {
  const p = PATHS[route];
  if (lang === 'en') return p;
  return route === 'home' ? AR_PREFIX : `${AR_PREFIX}${p}`;
}

export function demoHref(line?: Line): string {
  return line ? `${PATHS.demo}?line=${line}` : PATHS.demo;
}
